import {Card, Divider, Row, Tag, Typography} from "antd";
import { styled } from "styled-components";

export const StyledCard = styled(Card)`
    .ant-card-body{
        padding: 10px 10px;
    }
`;

